module.exports = __webpack_public_path__ + "img/Weapon_92.140ac953.png";